import { useEffect } from 'react';

export type SnackbarVariant = 'success' | 'error';

interface Props {
  open: boolean;
  variant?: SnackbarVariant;
  message: string;
  onClose: () => void;
  duration?: number;
}

const Snackbar = ({ open, variant = 'success', message, onClose, duration = 3000 }: Props) => {
  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [open, duration, onClose]);

  if (!open) return null;

  const isSuccess = variant === 'success';

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed bottom-4 right-4 z-50 px-4 py-3 rounded-lg shadow-md border text-sm flex items-center gap-2 ${
        isSuccess ? 'bg-success-light border-success text-success' : 'bg-error-light border-error text-error'
      }`}
    >
      <span>{message}</span>
      <button
        type="button"
        onClick={onClose}
        aria-label="Cerrar"
        className="ml-2 opacity-70 hover:opacity-100 cursor-pointer"
      >
        ✕
      </button>
    </div>
  );
};

export default Snackbar;
